import { makeStyles } from "@material-ui/core";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants";

export const RESET_STATE_DATA_FIXED_ASSET = {
  id: "",
  idgl: "",
  total_penyusutan: 0,
  total_cicilan:0,
  sisa_pemby:0,
  id_pembelian:null,
};

export const STYLE_DEFAULT_TAB_FA = makeStyles({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    background: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
    border: "1px solid rgb(230, 230, 230)",
    "& tr td": {
      border: "1px solid rgb(230, 230, 230)",
    },
  },
});